// Generado por scripts/gen-version.mjs. No editar ni versionar.
export const APP_VERSION = {
  "version": "1.25.0",
  "build": "61e38f66",
  "env": "production",
  "builtAt": "2026-11-04T03:30:22.370Z"
} as { version: string; build: string; env: string; builtAt: string };
